import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url,attendanceserver} from '@/utils/baseUrl';
//部门树
// export async function departTree(params) {
//     return post(attendanceserver+'/attendence/departTree', params, true)
// }
// 同步南北
export async function saveSNDepartment(params) {
    return post(oaserver+'/api/snmasterData/sn/saveSNDepartment ', params, true)
}
// 同步用友
export async function saveOrUpdateDepartment(params) {
    return post(oaserver+'/api/masterData/yy/saveOrUpdateDepartment', params, true)
}
//部门树
export async function getDeptTree(params) {
    return post(oaserver+'/organize/getDeptTree', params, true)
}
export async function addDept(params) {
    return post(oaserver+'/organize/addDept', params, true)
}
export async function editDept(params) {
    return post(oaserver+'/organize/editDept', params, true)
}
export async function getUserList(params) {
    return post(oaserver+'/organize/getUserList', params, true)
}
export async function getUserDetail(params) {
    return post(oaserver+'/organize/getUserDetail', params, true)
}
//公司列表
export async function getCompanyList(params) {
    return post(oaserver+'/organize/getCompanyList', params, true);
}
// //考勤方案列表
// export async function getKqList(params) {
//     return post(attendanceserver+'/kq/getKqList', params, true)
// }
